module.exports = __webpack_public_path__ + "img/champion.981907ae.png";